import { inject, observer } from "mobx-react";
import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Form, Radio, Segment } from "semantic-ui-react";
import { IAppModel } from "../../../AppModel";

interface INationality extends WithTranslation {
  onChangeInputField?: (fieldName: string, value: any) => void;
  inputFieldNationality: string;
  valueFieldNationality: number;
  inputFieldDescription?: string;
  valueFieldDescription?: string;
  readOnly?: boolean;
  appStore?: IAppModel;
}

@inject("appStore")
@observer
class Nationality extends React.Component<INationality> {
  public render() {
    const {
      inputFieldNationality,
      valueFieldNationality,
      readOnly,
      appStore
    } = this.props;
    return (
      <Segment>
        <div className="inline fields" style={styles.formGroup}>
          {appStore!
            .enumItems("nationality")
            .map((item: any, index: number) => (
              <React.Fragment key={index}>
                <Form.Field
                  control={Radio}
                  label={item.text}
                  value={item.text}
                  onChange={(
                    event: React.SyntheticEvent<HTMLElement>,
                    data: any
                  ) =>
                    this.onChangeInputField(inputFieldNationality, data.value)
                  }
                  checked={valueFieldNationality === item.text}
                  readOnly={readOnly}
                />
              </React.Fragment>
            ))}
        </div>
      </Segment>
    );
  }


  private onChangeInputField = (fieldName: string, value: any) => {
    const { onChangeInputField } = this.props;
    if (typeof onChangeInputField !== "undefined") {
      onChangeInputField(fieldName, value);
    }
  };
}

const styles: any = {
  formInput: {
    marginTop: 7
  },
  formGroup: {
    flexWrap: "wrap",
    flexDirection: "initial",
    marginBottom: 0
  }
};

export default withTranslation()(Nationality);
